import { render, staticRenderFns } from "./PopupQuiz.vue?vue&type=template&id=d7bd2c72&scoped=true&"
import script from "./PopupQuiz.vue?vue&type=script&lang=js&"
export * from "./PopupQuiz.vue?vue&type=script&lang=js&"
import style0 from "./PopupQuiz.vue?vue&type=style&index=0&id=d7bd2c72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7bd2c72",
  null
  
)

export default component.exports